module.exports = "/static/assets/237bf42c437b2886b3e3097b078d6369.png";